module.exports = __webpack_public_path__ + "img/copy.ef9085da.svg";